import { clearApplications } from "../../../store/actions/applicationActions";
import { authLogout } from "../../../store/actions/authActions";
import { clearMessage, setMessage } from "../../../store/actions/dialogActions";
import { setNotifications } from "../../../store/actions/notificationActions";
import API from "../../../store/api";
import { getApplications } from "./getApplications";

export const updateApplication = (id, applicationData, bearerAuth, formFunction) => {
  return async dispatch => {

    dispatch(setMessage({ type: 'LOAD' }))

    API.put(`/api/portal/application/${id}`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .send(applicationData)
      .ok(res => res.status === 200 || res.status === 401)
      .then((response) => {
        if (response.status === 200) {
          dispatch(clearMessage)
          dispatch(getApplications(bearerAuth))
          dispatch(setNotifications({
            type: 'success',
            message: 'Successfully updated.'
          }))
          formFunction();
        } else if (response.status === 401) {
          dispatch(clearApplications);
          dispatch(authLogout);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          }
        }
        dispatch(setMessage({
          title: 'Update About Failed',
          message: message,
          type: 'ERR',
        }))
      })
  }
}